import { defineMessages } from 'react-intl';

export default defineMessages({
  businessModelCardTitle: {
    defaultMessage: 'Your business model',
    description: 'Business Model Card - title',
    id: 'businessModelCard.title',
  },
});
